import React from 'react';
import FuseLoading from '@fuse/core/FuseLoading';

interface FuseSuspenseProps {
	children: React.ReactNode;
	loadingProps?: { delay: number };
}

/**
 * React Suspense defaults
 * For to Avoid Repetition
 */
function FuseSuspense({ children, loadingProps = { delay: 0 } }: FuseSuspenseProps) {
	return <React.Suspense fallback={<FuseLoading {...loadingProps} />}>{children}</React.Suspense>;
}

export default FuseSuspense;
